import { FlexBox } from '@dixa/lib-shared-habla';

import { useConversationRow } from '../../../utils/useConversationRow';

import { ConversationsTablePreviewButton } from './components/previewButton/conversationsTablePreviewButton';
import { ConversationsTableRowMenu } from './components/rowMenu/conversationsTableRowMenu';

/** Represents the content of the actions cell in the conversations table. */
export const ConversationsTableActions = (): JSX.Element => {
  const { conversation, renderAction } = useConversationRow();

  return (
    <FlexBox alignItems="center" justifyContent="flex-end">
      {renderAction ? (
        renderAction(conversation)
      ) : (
        <ConversationsTablePreviewButton />
      )}
      <ConversationsTableRowMenu />
    </FlexBox>
  );
};
